import React from 'react'

function LocationInformation({ property }) {
  return (
    <div className='mb-3 px-3'>
      {property?.data?.type?.name && (
        <h3 style={{ color: "#278C7E" }}>
          {property?.data?.type.name} en Venta
        </h3>
      )}
      {property.data?.tittle &&
        <h1>
          {property.data?.tittle &&
            property?.data?.tittle.replace(/Ref:\d+\*\*/i, '').slice(0, 45).length ?
            property?.data?.tittle.replace(/Ref:\d+\*\*/i, '').slice(0, 45)
            :
            `${property?.data?.type.name} ${property?.data?.quantity_rooms}D-${property?.data?.quantity_bathrooms}B`
          }
        </h1>
      }
      <span className="subhead-light">
        <i className="fas fa-map-marker-alt mt-1"></i>
        <span className="subhead-light"> {property?.data?.address}, {property?.data?.commune.name}, {property?.data?.region.name}, Chile</span>
      </span>
    </div>
  )
}

export default LocationInformation
